module.exports = "query userSearchSelector{userSearchSelector{id firstName lastName email estheticianId}}"